/**
 * Сесія чернеток — найменша частина сховища (`drafts.ts`), яку бере й документ входу: новий вхід
 * робить чернетки попереднього входу в цій вкладці чужими (states.md, розд. 7, умова 1). Окремий
 * модуль, бо все, що імпортує вхід, потрапляє в спільний з ним чанк (бюджет входу ≤ 100 КБ).
 */
export const DRAFT_PREFIX = 'draft:';
export const DRAFT_SID_KEY = 'cl:sid';
export const DRAFT_USER_KEY = 'cl:draft-user';

export function draftStorage(): Storage | null {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    // Доступ до сховища заборонено (налаштування браузера) — чернеток просто немає.
    return null;
  }
}

export function draftKeys(store: Storage): string[] {
  const keys: string[] = [];
  for (let i = 0; i < store.length; i++) {
    const key = store.key(i);
    if (key?.startsWith(DRAFT_PREFIX)) keys.push(key);
  }
  return keys;
}

/** Усі чернетки вкладки — 401, «сесію відкликано», вихід в іншій вкладці (умова 2). */
export function clearAllDrafts(): void {
  const store = draftStorage();
  if (!store) return;
  try {
    for (const key of draftKeys(store)) store.removeItem(key);
  } catch {
    // нічого
  }
}

/** Новий вхід — нова сесія чернеток: чернетки попереднього входу в цій вкладці стають чужими. */
export function rotateDraftSession(): void {
  const store = draftStorage();
  if (!store) return;
  try {
    clearAllDrafts();
    store.removeItem(DRAFT_SID_KEY);
    store.removeItem(DRAFT_USER_KEY);
  } catch {
    // нічого
  }
}
